const pt = {
  "nav.search": "Buscar...",
  "nav.moreOptions": "Mais opções",
  "nav.hide": "Ocultar",
  "nav.show": "Mostrar",
  "nav.logout": "Sair",
  "nav.language": "Idioma",
  "nav.dashboard": "Painel",
  "nav.inbox": "Conversas",
  "nav.crm": "CRM",
  "nav.agenda": "Agenda",
  "nav.business": "Meu negócio",
  "nav.admin": "Administração",
  "nav.email": "E-mail",
  "nav.whatsapp": "WhatsApp",
  "nav.marketing": "Marketing",
  "nav.plan": "Meu plano",
  "nav.integrations": "Integrações",
  "nav.setup": "Atendimento automático",
  "nav.ai": "Config. IA",
  "nav.reports": "Relatórios",
  "nav.social": "Social & Ads",
  "nav.web": "Site",
  "mkt.title": "Marketing",
  "mkt.sub": "Captação e crescimento. E-mail e WhatsApp em massa ficam no menu lateral.",
  "mkt.home": "Início",
  "mkt.origins": "Origens de leads",
  "mkt.lists": "Listas",
  "mkt.automations": "Sequências",
  "mkt.more": "Mais",
  "mkt.campaigns": "Campanhas (avançado)",
  "mkt.contacts": "Contatos",
  "mkt.schedules": "Calendário de envios",
  "mkt.delivery": "Testes de envio",
  "mkt.whatToday": "O que você quer fazer hoje?",
  "mkt.whatTodaySub": "Aqui está a captação (QR, listas, automáticos). Para e-mail ou WhatsApp em massa use o menu lateral.",
  "mkt.originsTitle": "Origens de leads",
  "mkt.originsSub": "WhatsApp por frase, QR, portais, web…",
  "mkt.originsP1": "Crie um QR com mensagem inicial",
  "mkt.originsP2": "O lead escreve e entra no seu fluxo / IA",
  "mkt.originsP3": "Baixe e imprima em segundos",
  "mkt.originsCta": "Configurar origens",
  "mkt.audienceTitle": "Listas e audiências",
  "mkt.audienceSub": "Com quem você fala em cada envio",
  "mkt.audienceP1": "Landing ou formulário conectado ao CRM",
  "mkt.audienceP2": "Dispara fluxos e atribuição",
  "mkt.audienceP3": "Ideal para campanhas digitais",
  "mkt.audienceCta": "Ver origens",
  "mkt.segmentsTitle": "Listas / segmentos",
  "mkt.segmentsText": "Para quem você envia (aniversários, etapa CRM, datas…)",
  "mkt.autoTitle": "Sequências de nurturing",
  "mkt.nurtureHint": "Configure como nutrir leads automaticamente por e-mail e WhatsApp.",
  "mkt.autoText": "Boas-vindas, consultas, aniversários, reativação e mais.",
  "mkt.massSection": "Envios em massa (módulos separados)",
  "mkt.emailMass": "E-mail em massa",
  "mkt.emailMassSub": "Mailing SES · modelos · relatórios",
  "mkt.waMass": "WhatsApp em massa",
  "mkt.waMassSub": "Modelos Meta · envios · conexão API",
  "mkt.statLeads": "Leads",
  "mkt.statTpl": "Modelos WA",
  "mkt.statDrafts": "Campanhas rascunho",
  "mkt.statAuto": "Automáticos ativos",
  "email.home": "Início",
  "email.new": "Novo envio",
  "email.history": "Histórico",
  "email.templates": "Modelos",
  "email.domain": "Meu domínio",
  "email.reports": "Relatórios",
  "email.title": "E-mail",
  "email.sub": "E-mail em massa com a sua marca",
  "wa.home": "Início",
  "wa.connection": "Conexão",
  "wa.sends": "Envios",
  "wa.templates": "Modelos",
  "wa.reports": "Relatórios",
  "wa.title": "WhatsApp",
  "wa.sub": "Envios em massa e conexão Business API",
  "crm.pipeline": "Pipeline",
  "crm.leads": "Leads",
  "crm.tasks": "Tarefas",
  "crm.templates": "Modelos",
  "inbox.all": "Todas",
  "inbox.open": "Abertas",
  "inbox.closed": "Fechadas",
  "agenda.calendar": "Calendário",
  "agenda.resources": "Serviços e recursos",
  "agenda.tables": "Mapa de mesas",
  "biz.summary": "Meu negócio",
  "biz.team": "Minha equipe",
  "biz.assignment": "Atribuição",
  "biz.flows": "Construtor de fluxos",
  "biz.profile": "Perfil e horário",
  "biz.locations": "Filiais",
  "rep.status": "Estado",
  "rep.detail": "Detalhe técnico",
  "common.loading": "Carregando…",
  "common.cancel": "Cancelar",
  "common.save": "Salvar",
  "common.next": "Seguinte",
  "common.back": "Voltar",
  "common.edit": "Editar",
  "common.delete": "Excluir",
  "common.create": "Criar",
  "common.view": "Ver",
  "common.close": "Fechar",
  "common.copy": "Copiar",
  "common.search": "Buscar",
  "common.active": "Ativo",
  "common.inactive": "Inativo",
  "origins.title": "Origens de leads",
  "origins.sub": "Uma origem = meio + como chega + campanha. WhatsApp, chamada, webhook ou e-mail inteligente.",
  "origins.create": "Criar origem",
  "origins.edit": "Editar",
  "origins.connection": "Dados de conexão",
  "origins.webhook": "Webhook",
  "origins.email": "E-mail inteligente",
  "origins.secret": "Secret",
  "origins.secretOnce": "Secret (copie agora; o valor completo só aparece uma vez)",
  "origins.regen": "Regenerar secret",
  "origins.copy": "Copiar",
  "origins.free": "Mensagens livres do WhatsApp",
  "origins.freeHelp": "Sempre ativa. Chats sem frase de campanha ou se o lead apagar o texto.",
  "origins.empty": "Ainda não há origens",
  "origins.leads": "leads",
  "origins.save": "Salvar alterações",
  "origins.close": "Fechar",
  "origins.howTo": "Como conectar",
  "lang.es": "Español",
  "lang.en": "English",
  "lang.de": "Deutsch",
  "lang.pt": "Português",
  "lang.choose": "Idioma",
  "lang.auto": "Automático (por região)",
  "login.title": "Entrar",
  "login.subtitle": "Acesse o seu negócio",
  "login.email": "E-mail",
  "login.password": "Senha",
  "login.name": "Nome",
  "login.submit": "Entrar",
  "login.register": "Criar conta",
  "login.haveAccount": "Já tem conta? Entrar",
  "login.noAccount": "Não tem conta? Cadastre-se",
  "login.forgot": "Esqueceu a senha?",
  "login.mfa": "Verificação em duas etapas",
  "login.mfaHint": "Digite o código de 6 dígitos do autenticador ou um código de backup.",
  "login.code": "Código",
  "login.inactive": "Sua sessão encerrou após 60 minutos de inatividade.",
  "login.titleRegister": "Criar conta",
  "login.titleLogin": "Entrar",
  "login.emailLabel": "E-mail",
  "login.passwordLabel": "Senha",
  "login.nameLabel": "Nome completo",
  "login.submitLogin": "Entrar",
  "login.submitRegister": "Criar conta",
  "login.switchToLogin": "Já tem conta? Entrar",
  "login.switchToRegister": "Não tem conta? Cadastre-se",
  "login.heroTitle": "Seu negócio, automatizado",
  "login.heroSub": "Atendimento, vendas e acompanhamento em um só lugar.",
  "login.verify": "Verificar",
  "dash.welcome": "Bem-vindo",
  "dash.overview": "Visão geral do seu negócio",
  "admin.pos": "Ponto de venda",
  "admin.warranty": "Mesa de serviço",
  "admin.condo": "Gestão condominial",
  "admin.sub": "Operação do negócio: ponto de venda e caixa",
  "filtros.from": "De",
  "filtros.to": "Até",
  "filtros.seller": "Vendedor",
  "filtros.group": "Grupo",
  "filtros.campaign": "Campanha",
  "filtros.clear": "Limpar filtros",
  "common.all": "Todos",
  "common.all_f": "Todas",
};
export default pt;
